/**

 * @author Owais

 * @datetime July, 14th 2022

 * @description: This is Error Interceptor give a error from http request, retry 3 times after failer of call. 
 * still have an error print in console in dev env

 */

import { Injectable, NgZone } from '@angular/core';
import {
  HttpEvent,
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { checkGenericErrors } from 'src/app/shared/errors/generic-error-response';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { UserLoginService } from 'src/app/shared/services/user-login.service';
import { Router } from '@angular/router';
import { ERROR_CODES } from 'src/app/shared/constants/error-codes';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorInterceptorInterceptor implements HttpInterceptor {
  constructor(
    private zone: NgZone,
    private notificationService: NotificationService,
    private userService: UserLoginService,
    private router: Router,
    private translateService: TranslateService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      retry(3),
      catchError((error: HttpErrorResponse) => {
        if (window.__dev__) console.log(error);

        if (error instanceof HttpErrorResponse) {
          if (error.status === Number(ERROR_CODES.ERROR_REQUEST_UNAUTHORIZED)) {
            this.userService.logout().subscribe({
              next: () => {
                window.location.href = window.location.origin + '/login';
              },
              error: (err: Error) => {
                if (window.__dev__)
                  console.log('ErrorInterceptorInterceptor', err);
              },
            });
          }
          checkGenericErrors(error.message, this.translateService);
        }

        this.zone.run(() => this.notificationService.showError(error.message));
        return throwError(error);
      }),
      catchError((error: any) => {
        this.zone.run(() => this.notificationService.showError(error.message));
        return throwError(error);
      })
    );
  }
}
